import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { LocalStorageService } from 'ngx-webstorage';

@Component({
  selector: 'app-un-bet-limit-model',
  templateUrl: './un-bet-limit-model.component.html',
  styleUrls: ['./un-bet-limit-model.component.scss']
})
export class UnBetLimitModelComponent implements OnInit {
  title: string;
  closeBtnName: string; 
  term_conditions: any;
  @Input() data: any=[];  
  description: any[];
  
  constructor(private storage: LocalStorageService,public bsModalRef: BsModalRef,private translateService: TranslateService, private router: Router,) {
   
  }
 
  ngOnInit() 
  {  
   
    this.closeBtnName= this.translateService.instant('cancel');
    this.term_conditions=this.translateService.instant('term_conditions'); 
  }
  unBetLimitListModalDelete(){
    this.bsModalRef.hide();
    this.router.navigate(['/threed/bet-confirm'],{replaceUrl:true});
  }
  goWallet()
  {
    this.bsModalRef.hide();
    this.router.navigate(['/threed/bet-confirm'],{replaceUrl:true});
  }
  

}